export const MENU_ITEM_DISPLAY_NAME = 'MenuItem'

export enum MenuItemMarkup {
  li = 'li',
  div = 'div',
}

export enum DropdownMenuBorderStyle {
  DEFAULT = '',
  NO_BORDER = 'dropdownMenuNoBorder',
}
